import { IamGroupType, SmoketestPermissionLevel } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useMemo, useState } from 'react';

import { ApiErrorMessageInternal, NoddiAsyncSelect, SelectOption } from 'noddi-ui-web';
import { buildAssigneeOptions, renderAssigneeOption } from './assigneeOption';

type Props = {
  selectedOption?: SelectOption<number>;
  onSelectionChange: (option: SelectOption<number> | undefined) => void;
  label?: string;
  placeholder?: string;
  className?: string;
};

const ASSIGNEE_ROLES: SmoketestPermissionLevel[] = [
  SmoketestPermissionLevel.STAFF,
  SmoketestPermissionLevel.WORKER,
  SmoketestPermissionLevel.SUPERUSER
];
const ASSIGNEE_GROUP_TYPES: IamGroupType[] = [IamGroupType.PERSONAL];

export const TicketAssigneePicker = ({
  selectedOption,
  onSelectionChange,
  label,
  placeholder = 'Search staff, workers, or superusers...',
  className
}: Props) => {
  const [search, setSearch] = useState('');

  const { data, isFetching, error } = noddiAsync.useGet({
    type: URLKeys.getPaginatedUserGroups,
    input: { pageIndex: 0, pageSize: 20, search, roles: ASSIGNEE_ROLES, types: ASSIGNEE_GROUP_TYPES }
  });

  const options = useMemo(() => buildAssigneeOptions(data?.results ?? []), [data?.results]);

  if (error) {
    return <ApiErrorMessageInternal error={error} />;
  }

  return (
    <NoddiAsyncSelect<number>
      label={label}
      placeholder={placeholder}
      selectedOption={selectedOption}
      onSelectionChange={onSelectionChange}
      onSearch={setSearch}
      options={options}
      isLoading={isFetching}
      className={className}
      renderOption={renderAssigneeOption}
    />
  );
};
